import capitalize from 'lodash.capitalize';

import { selectFirstName, selectLastName } from '../../redux/auth/user/selectors';
import { createDeepEqualSelector } from '../../redux/utils/selectors';

export const selectFullName = createDeepEqualSelector([selectFirstName, selectLastName], (firstName, lastName) =>
  `${capitalize(firstName)} ${capitalize(lastName)}`.trim(),
);

export const selectInitials = createDeepEqualSelector(
  [selectFirstName, selectLastName],
  (firstName, lastName) => `${capitalize(firstName).charAt(0)}${capitalize(lastName).charAt(0)}`,
);
